"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Accountability() {
  const header = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const pillar1 = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const pillar2 = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const pillar3 = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const pillars = [{
    index: "01",
    label: "INTEGRITY",
    title: "Unwavering commitment to ethical standards",
    body: "We operate with complete honesty in every project phase. Our team maintains rigorous documentation of all decision-making processes, ensuring that our clients and stakeholders can verify our actions and trust the integrity of our project management outcomes.",
    colStart: "lg:col-start-1",
    colSpan: "lg:col-span-5",
    refObj: pillar1,
    delay: "0ms",
    showTopRule: false
  }, {
    index: "02",
    label: "VISIBILITY",
    title: "Real-time reporting and open communication",
    body: "We believe in total project visibility. By providing clear, accessible data dashboards and regular progress updates, we ensure that every stakeholder remains informed. We treat transparency as a fundamental requirement for successful infrastructure delivery.",
    colStart: "lg:col-start-4",
    colSpan: "lg:col-span-6",
    refObj: pillar2,
    delay: "150ms",
    showTopRule: true
  }, {
    index: "03",
    label: "PARTNERSHIP",
    title: "Integrated collaboration across all sectors",
    body: "Infrastructure challenges require a unified approach. We bring together engineers, public officials, and community leaders to solve complex problems collectively. By sharing resources and expertise, we deliver results that are more resilient and impactful for the public.",
    colStart: "lg:col-start-7",
    colSpan: "lg:col-span-6",
    refObj: pillar3,
    delay: "300ms",
    showTopRule: true
  }];
  return;
}